<template>
  <div class="purchase-order-material-select hmd-btn">
    <a-button :disabled="!orderId" type="primary" @click="showModal">源单导入</a-button>

    <!-- <a-modal
      v-model:visible="visible"
      :keyboard="false"
      :centered="true"
      :mask-closable="false"
      width="90%"
      @ok="ok"
      @cancel="closeModal"
    >
      <template #title>
        <span>选择材料</span>
        <small>点击确定会将右侧待选列表中的项目加入目标清单</small>
      </template>
      <div class="purchase-order-material-select__modal">
        <div class="purchase-order-material-select__modal__main">
          <material-table :order-id="orderId" v-model:value="currentMaterialList"></material-table>
        </div>
        <div class="purchase-order-material-select__modal__right">
          <selected-table v-model:value="currentMaterialList"></selected-table>
        </div>
      </div>
    </a-modal> -->
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { LibraryListRecord } from "@/views/material/library/library.interface";
import MaterialTable from "./material-table/index.vue";
import SelectedTable from "./selected-table/index.vue";
import { hmdConfirm } from "@/dialog/index";
/**
 * 采购订单材料选择
 */
export default defineComponent({
  name: "PurchaseOrderMaterialSelect",
  components: { MaterialTable, SelectedTable },
  props: {
    orderId: { type: String, default: "" },

    value: { type: Array as PropType<string[]>, default: () => [] },
  },
  emits: ["update:value", "change"],
  setup(props, { attrs, slots, emit }) {
    const state = reactive<{
      visible: boolean;
      currentMaterialList: LibraryListRecord[];
    }>({
      visible: false,
      currentMaterialList: [],
    });

    const showModal = () => {
      state.visible = true;
      hmdConfirm({
        com: import("./dialog.vue"),
        params: {
          //@ts-ignore
          orderId:props.orderId,
          value:props.value,
        },
        confirm:({res})=>{
          let {ids,currentMaterialList}=res
          emit("update:value", ids);
          emit("change", currentMaterialList);
        }
      });
    };

    const closeModal = () => {
      state.visible = false;
      state.currentMaterialList = [];
    };

    const ok = () => {
      const ids = state.currentMaterialList.map((item) => item.id);
      if (ids.length === 0) {
        message.warning("请选择材料，加入待选列表");
        return;
      }
      emit("update:value", ids);
      emit("change", state.currentMaterialList);
      closeModal();
    };

    return {
      ...toRefs(state),
      showModal,
      closeModal,
      ok,
    };
  },
});
</script>

<style lang="less" scoped>
.purchase-order-material-select {
  display: inline-block;
}
</style>

<style lang="less">
.purchase-order-material-select__modal {
  position: relative;
  padding: 0 415px 0 0;
  min-height: 500px;

  &__right {
    position: absolute;
    top: 0;
    height: 100%;
    overflow-y: auto;
  }

  &__right {
    right: 0;
    width: 400px;
  }
}
</style>
